export const toDecimal = (num, maximumFractionDigits = 3) => {
    const factor = parseInt('1'.padEnd(maximumFractionDigits + 1, '0'));

    return num ? Math.round(num * factor) / factor : '';
}